import { render, staticRenderFns } from "./StatisticCardVerticalNeutral.vue?vue&type=template&id=13e9e2ae&"
import script from "./StatisticCardVerticalNeutral.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalNeutral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports